<template>
  <v-container id="productos" tag="section">
    <base-material-card
      color="indigo"
      icon="mdi-basket"
      inline
      class="px-5 py-3"
    >
      <v-toolbar flat color="white">
        <v-btn color="success" dark class="mb-2" @click="goBack">Volver</v-btn>
        <v-btn
          color="info"
          dark
          class="mb-2 ml-4"
          @click="accion = 'configurar'"
          v-if="!isConfigurar"
          >Configurar</v-btn
        >
        <v-btn
          color="info"
          dark
          class="mb-2 ml-4"
          @click="accion = 'precio'"
          v-if="!isPrecio"
          >Precios</v-btn
        >
        <v-btn
          color="info"
          dark
          class="mb-2 ml-4"
          @click="accion = 'compatibilidad'"
          v-if="!isCompatibilidad"
          >Compatibilidades</v-btn
        >
        <v-btn
          color="info"
          dark
          class="mb-2 ml-4"
          @click="accion = 'mapeo'"
          v-if="!isMapeo"
          >Mapeo</v-btn
        >
        <v-btn
          color="info"
          dark
          class="mb-2 ml-4"
          @click="accion = 'maxandmin'"
          v-if="!isMaxandmin"
          >Límites Max y Min</v-btn
        >
        <v-spacer></v-spacer>
        <v-btn
          color="success"
          dark
          class="mb-2"
          @click="addPanel()"
          v-if="isConfigurar"
          >Añadir Panel</v-btn
        >
      </v-toolbar>
      <v-card-text>
        <h3>{{ title }}</h3>
        <v-spacer />
        <v-select
          v-if="isConfigurar"
          :items="idiomas"
          v-model="langSeleccionado"
          label="Selección idioma"
          outline
        ></v-select>
        <!--CONFIGURAR-->
        <v-item-group v-if="isConfigurar">
          <v-container grid-list-md>
            <v-row>
              <draggable
                tag="div"
                class="row"
                @change="cambioOrden"
                v-model="items"
              >
                <v-col
                  cols="12"
                  md="4"
                  v-for="(item, i) in items"
                  :key="i"
                  xs12
                  md4
                >
                  <v-item>
                    <v-card
                      slot-scope="{ active }"
                      :color="active ? 'primary' : ''"
                      elevation="100"
                    >
                      <!--<v-scroll-y-transition>
                                        <div
                                        v-if="active"
                                        class="display-3 text-xs-center"
                                        >
                                        Active
                                        </div>
                    </v-scroll-y-transition>-->
                      <v-toolbar color="secondary" dark>
                        <v-toolbar-title
                          @click="editarPanel(i)"
                          class="white--text"
                        >
                          <h4 v-if="!item.editando">
                            <v-icon style="display: inline">mdi-hand</v-icon>
                            {{ mostrarNombre(item.panel) }}
                          </h4>
                          <v-text-field
                            v-else
                            v-model="fieldEdicionPanelShow"
                            @blur="blurPanel(i)"
                            label="Nombre panel"
                            autofocus
                          ></v-text-field>
                        </v-toolbar-title>

                        <v-spacer></v-spacer>
                      </v-toolbar>
                      <v-list>
                        <v-list-item
                          v-for="(op, i_a) in item.opciones"
                          :key="i_a"
                          avatar
                        >
                          <template v-if="op && !op.editando">
                            <v-list-item-content>
                              <v-list-item-title
                                @click="editarOpcion(i, i_a)"
                                v-text="mostrarNombre(op.title)"
                              ></v-list-item-title>
                            </v-list-item-content>
                            <v-list-item-icon>
                              <v-icon @click="removeOpcion(i, i_a)"
                                >mdi-minus</v-icon
                              >
                            </v-list-item-icon>
                          </template>
                          <template v-else-if="op">
                            <v-text-field
                              v-model="fieldEdicionOpcionShow"
                              @blur="blur(i, i_a)"
                              label="Nombre opción"
                              autofocus
                            ></v-text-field>
                          </template>
                        </v-list-item>
                        <v-card-actions>
                          <v-layout align-center justify-center>
                            <v-spacer />
                            <v-icon @click="addOpcion(item)">mdi-plus</v-icon>
                            <v-spacer />
                            <v-icon @click="removePanel(i)">mdi-minus</v-icon>
                            <v-spacer />
                          </v-layout>
                        </v-card-actions>
                      </v-list>
                    </v-card>
                  </v-item>
                </v-col>
              </draggable>
            </v-row>
          </v-container>
        </v-item-group>
        <!--END CONFIGURAR-->
        <!--COMPATIBILIDADES-->
        <v-item-group v-if="isCompatibilidad">
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex v-for="(item, i) in items" :key="i" xs12 md4>
                <v-item>
                  <v-card
                    slot-scope="{ active }"
                    :color="active ? 'primary' : ''"
                    elevation="100"
                  >
                    <v-toolbar color="secondary" dark>
                      <v-toolbar-title class="white--text">
                        <h4>{{ mostrarNombre(item.panel) }}</h4>
                      </v-toolbar-title>

                      <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-list>
                      <v-list-item
                        v-for="(op, i_a) in item.opciones"
                        :key="i_a"
                        avatar
                      >
                        <template>
                          <v-list-item-icon
                            v-if="op.linkPre"
                            @click="marcarComp(op)"
                          >
                            <v-icon v-if="op.linkPre == 'green'" color="green"
                              >mdi-link-variant</v-icon
                            >
                            <v-icon v-else color="red"
                              >mdi-link-variant-off</v-icon
                            >
                          </v-list-item-icon>
                          <v-list-item-content
                            :class="claseOpcion(op)"
                            @click="compaMarcarOpcion(i, i_a, op)"
                          >
                            <v-list-item-title
                              v-text="mostrarNombre(op.title)"
                            ></v-list-item-title>
                          </v-list-item-content>
                          <v-list-item-icon
                            v-if="op.linkPost"
                            @click="marcarComp(op)"
                          >
                            <v-icon v-if="op.linkPost == 'green'" color="green"
                              >mdi-link-variant</v-icon
                            >
                            <v-icon v-else color="red"
                              >mdi-link-variant-off</v-icon
                            >
                          </v-list-item-icon>
                        </template>
                      </v-list-item>
                      <v-card-actions>
                        <v-layout align-center justify-center>
                          <v-spacer />
                          <v-select
                            :items="tipos"
                            v-model="item.tipo"
                            label="Tipo"
                          ></v-select>
                          <v-spacer />
                        </v-layout>
                      </v-card-actions>
                    </v-list>
                  </v-card>
                </v-item>
              </v-flex>
            </v-layout>
          </v-container>
        </v-item-group>
        <!--END COMPATIBILIDADES-->
        <!--MAPEO-->
        <v-item-group v-if="isMapeo">
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex v-for="(item, i) in items" :key="i" xs12 md4>
                <v-item>
                  <v-card
                    slot-scope="{ active }"
                    :color="active ? 'primary' : ''"
                    elevation="100"
                  >
                    <v-toolbar color="secondary" dark>
                      <v-toolbar-title class="white--text">
                        <h4>{{ mostrarNombre(item.panel) }}</h4>
                      </v-toolbar-title>

                      <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-list>
                      <v-list-item
                        v-for="(op, i_a) in item.opciones"
                        :key="i_a"
                        avatar
                      >
                        <template>
                          <v-list-item-content>
                            <v-list-item-title
                              v-text="mostrarNombre(op.title)"
                            ></v-list-item-title>
                          </v-list-item-content>
                          <v-list-item-action>
                            <v-icon
                              :color="getColorMapeo(op)"
                              @click="openDialogMapeando(op)"
                              >mdi-vector-link</v-icon
                            >
                          </v-list-item-action>
                        </template>
                      </v-list-item>
                    </v-list>
                  </v-card>
                </v-item>
              </v-flex>
            </v-layout>
          </v-container>
          <v-dialog v-model="dialogMapeo">
            <v-card>
              <v-card-title>
                <span class="headline"
                  >Mapeo con Neo opcion {{ opcionMapeo }}</span
                >
              </v-card-title>
              <v-card-text>
                <v-toolbar flat color="white">
                  <v-btn
                    v-if="mostrarTablaTodos"
                    @click="mostrarTablaTodos = false"
                    color="primary"
                    >Mostrar Opciones</v-btn
                  >
                  <v-btn
                    v-else
                    @click="mostrarTablaTodos = true"
                    color="primary"
                    >Mostrar Todos</v-btn
                  >
                  <v-text-field
                    v-model="searchNeo"
                    append-icon="mdi-magnify"
                    label="Buscar"
                    single-line
                    hide-details
                  ></v-text-field>
                  <v-spacer></v-spacer>
                  <v-btn
                    v-if="mostrarTablaTodos"
                    color="success"
                    @click="getProductosNeo"
                  >
                    <v-icon color="white">mdi-autorenew</v-icon>
                  </v-btn>
                  <v-btn color="success" @click="saveMapeo()">
                    <v-icon color="white">mdi-floppy</v-icon>
                  </v-btn>
                </v-toolbar>

                <v-data-table
                  v-if="mostrarTablaTodos"
                  v-model="selectedNeo"
                  item-key="Codigo"
                  single-select
                  :headers="headersNeo"
                  :items="productosNeo"
                  :loading="loadingNeo"
                  :search="searchNeo"
                  show-select
                ></v-data-table>
                <v-data-table
                  v-else
                  v-model="selectedNeoOpcion"
                  item-key="Codigo"
                  single-select
                  :headers="headersNeoOpciones"
                  :items="productosNeoOpciones"
                  :loading="loadingNeo"
                  :search="searchNeo"
                  show-select
                ></v-data-table>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="close"
                  >Cancelar</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-item-group>
        <!--END MAPEO-->
        <!--PRECIO-->
        <v-item-group v-if="isPrecio">
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex v-for="(item, i) in items" :key="i" xs12 md4>
                <v-item>
                  <v-card
                    slot-scope="{ active }"
                    :color="active ? 'primary' : ''"
                    elevation="100"
                  >
                    <v-toolbar color="secondary" dark>
                      <v-toolbar-title class="white--text">
                        <h4>{{ mostrarNombre(item.panel) }}</h4>
                      </v-toolbar-title>

                      <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-list>
                      <v-list-item
                        v-for="(op, i_a) in item.opciones"
                        :key="i_a"
                        avatar
                      >
                        <template>
                          <v-list-item-content>
                            <v-list-item-title
                              v-text="mostrarNombre(op.title)"
                            ></v-list-item-title>
                          </v-list-item-content>
                          <v-list-item-action>
                            <v-text-field
                              v-model="op.precio"
                              label="precio"
                              type="number"
                              step="0.5"
                            />
                          </v-list-item-action>
                        </template>
                      </v-list-item>
                    </v-list>
                  </v-card>
                </v-item>
              </v-flex>
            </v-layout>
          </v-container>
        </v-item-group>
        <!--END PRECIO-->
        <!--MAXANDMIN-->
        <v-item-group v-if="isMaxandmin">
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex v-for="(item, i) in items" :key="i" xs12 md4>
                <v-item>
                  <v-card
                    slot-scope="{ active }"
                    :color="active ? 'primary' : ''"
                    elevation="100"
                  >
                    <v-toolbar color="secondary" dark>
                      <v-toolbar-title class="white--text">
                        <v-row align="center" justify="center" no-gutters>
                          <v-col cols="6"
                            ><h4>{{ mostrarNombre(item.panel) }}</h4></v-col
                          >
                          <v-col cols="3" class="mt-4">
                            <v-text-field
                              v-model="item.max"
                              label="max"
                              type="number"
                              step="1"
                          /></v-col>
                          <v-col cols="3" class="mt-4">
                            <v-text-field
                              v-model="item.min"
                              label="min"
                              type="number"
                              step="1"
                          /></v-col>
                        </v-row>
                      </v-toolbar-title>

                      <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-list>
                      <v-list-item
                        v-for="(op, i_a) in item.opciones"
                        :key="i_a"
                        avatar
                      >
                        <template>
                          <v-col cols="6">
                            <v-list-item-content>
                              <v-list-item-title
                                v-text="mostrarNombre(op.title)"
                              ></v-list-item-title>
                            </v-list-item-content>
                          </v-col>
                          <v-col cols="6">
                            <v-list-item-action> </v-list-item-action
                          ></v-col>
                        </template>
                      </v-list-item>
                    </v-list>
                  </v-card>
                </v-item>
              </v-flex>
            </v-layout>
          </v-container>
        </v-item-group>
        <!--END MAXANDMIN-->
      </v-card-text>
    </base-material-card>
  </v-container>
</template>

<script>
import { key } from "firebase-key";
import { mapState, mapGetters } from "vuex";
import { mostrarIdioma } from "@/utils/utils.js";
import draggable from "vuedraggable";

export default {
  components: {
    draggable,
  },
  data() {
    return {
      fieldEdicionOpcion: "",
      fieldEdicionPanel: null,
      accion: "configurar", //configurar, compatibilidad, mapeo
      items: [],
      //COMPATIBILIDADES
      keyManejando: null,
      tipos: [
        {
          value: "simple",
          text: "Simple",
        },
        {
          value: "multi",
          text: "Multiple",
        },
        {
          value: "ultramulti",
          text: "Ultra Multiple",
        },
      ],
      mostrarTablaTodos: true,
      itemMapeando: null,
      searchNeo: "",
      loadingNeo: false,
      loadingMapeo: false,
      selectedNeo: [],
      selectedNeoOpcion: [],
      dialogMapeo: false,
      headersNeo: [
        {
          sortable: false,
          text: "Codigo",
          value: "Codigo",
        },
        {
          sortable: false,
          text: "Nombre",
          value: "Nombre",
        },
        {
          sortable: false,
          text: "Tipo",
          value: "Tipo",
        },
      ],
      headersNeoOpciones: [
        {
          sortable: false,
          text: "Codigo",
          value: "Codigo",
        },
        {
          sortable: false,
          text: "Nombre",
          value: "nombreNeo",
        },
        {
          sortable: false,
          text: "Código Elemento",
          value: "codElemento",
        },
      ],
      productosNeoOpciones: [],
    };
  },
  computed: {
    ...mapState({
      idiomas: "idiomas",
      langDefecto: "langDefecto",
      productoEditando: (state) => state.productos.productoEditando,
      productosNeo: (state) => state.neo.productosNeo,
    }),
    ...mapGetters({
      //productosNeoOpciones: "neo/getNeoOpcionesMapear"
    }),
    langSeleccionado: {
      get() {
        return this.$store.state.langSeleccionado;
      },
      set(v) {
        this.$store.commit("setLangSeleccionado", v);
      },
    },
    title() {
      let res = "";
      switch (this.accion) {
        case "configurar":
          res = "Construir producto";
          break;
        case "compatibilidad":
          res = "Manejar compatibilidades";
          break;
        case "mapeo":
          res = "Manejar mapeo Neo";
          break;
      }
      return res;
    },
    isConfigurar() {
      return this.accion == "configurar";
    },
    isCompatibilidad() {
      return this.accion == "compatibilidad";
    },
    isMapeo() {
      return this.accion == "mapeo";
    },
    isMaxandmin() {
      return this.accion == "maxandmin";
    },
    isPrecio() {
      return this.accion == "precio";
    },
    viendoOpciones: {
      get() {
        return this.$store.state.productos.viendoOpciones;
      },
      set(v) {
        this.$store.commit("productos/setViendoOpciones", v);
      },
    },
    fieldEdicionPanelShow: {
      get() {
        var found = this.fieldEdicionPanel.find(
          (e) => e.lang == this.langSeleccionado
        );
        return found ? found.text : "";
      },
      set(v) {
        var index = this.fieldEdicionPanel.findIndex(
          (e) => e.lang == this.langSeleccionado
        );
        //var defecto = this.nombreIdiomas.find(e => e.lang == _vm.langDefecto)
        //this.nombreValidar = defecto.text;
        this.fieldEdicionPanel[index].text = v;
      },
    },
    fieldEdicionOpcionShow: {
      get() {
        var found = this.fieldEdicionOpcion.find(
          (e) => e.lang == this.langSeleccionado
        );
        return found ? found.text : "";
      },
      set(v) {
        var index = this.fieldEdicionOpcion.findIndex(
          (e) => e.lang == this.langSeleccionado
        );
        //var defecto = this.nombreIdiomas.find(e => e.lang == _vm.langDefecto)
        //this.nombreValidar = defecto.text;
        this.fieldEdicionOpcion[index].text = v;
      },
    },
    opcionMapeo() {
      return this.itemMapeando ? mostrarIdioma(this.itemMapeando.title) : "";
    },
  },
  watch: {
    dialogMapeo(val) {
      val || this.close();
    },
    selectedNeo(val) {
      if (val.length > 0) {
        this.selectedNeoOpcion = [];
      }
    },
    selectedNeoOpcion(val) {
      if (val.length > 0) {
        this.selectedNeo = [];
      }
    },
  },
  methods: {
    cambioOrden() {
      console.log(this.items);
    },
    removeA(arr) {
      var what,
        a = arguments,
        L = a.length,
        ax;
      while (L > 1 && arr.length) {
        what = a[--L];
        while ((ax = arr.indexOf(what)) !== -1) {
          arr.splice(ax, 1);
        }
      }
      return arr;
    },
    goBack() {
      this.limpiarOpcionCompatibilidades();
      this.$store.commit("productos/setOpcionesEditadas", this.items);
      this.viendoOpciones = false;
      this.accion = "configurar";
    },
    mostrarNombre(str) {
      var found = str.find((e) => e.lang == this.langSeleccionado);
      return found ? found.text : "";
    },
    addPanel() {
      let nombrePanel = [];
      this.idiomas.forEach((lang) => {
        nombrePanel.push({
          lang: lang.value,
          text: "Panel " + lang.text,
        });
      });
      let panel = {
        panel: nombrePanel,
        tipo: "simple",
        opciones: [],
      };
      this.items.push(panel);
    },
    removePanel(i) {
      let aux = JSON.parse(JSON.stringify(this.items));
      this.removeA(aux, aux[i]);
      this.items = aux;
    },
    addOpcion(item) {
      let nombreOpcion = [];
      this.idiomas.forEach((lang) => {
        nombreOpcion.push({
          lang: lang.value,
          text: "Opcion " + lang.text,
        });
      });
      item.opciones.push({
        title: nombreOpcion,
        id: key(),
        incomp: [],
      });
    },
    removeOpcion(i, i_a) {
      let aux = JSON.parse(JSON.stringify(this.items));
      this.removeA(aux[i].opciones, aux[i].opciones[i_a]);
      this.items = aux;
    },
    editarPanel(i) {
      let aux = JSON.parse(JSON.stringify(this.items));
      aux.forEach((element) => {
        delete element.editando;
      });
      aux[i].editando = true;
      this.fieldEdicionPanel = aux[i].panel;
      this.items = aux;
    },
    editarOpcion(i, i_a) {
      let aux = JSON.parse(JSON.stringify(this.items));
      aux.forEach((element) => {
        let ops = element.opciones;
        ops.forEach((op) => {
          delete op.editando;
        });
      });
      aux[i].opciones[i_a].editando = true;
      this.fieldEdicionOpcion = aux[i].opciones[i_a].title;
      this.items = aux;
    },
    blur(i, i_a) {
      let aux = JSON.parse(JSON.stringify(this.items));
      aux.forEach((element) => {
        let ops = element.opciones;
        ops.forEach((op) => {
          delete op.editando;
        });
      });
      aux[i].opciones[i_a].title = this.fieldEdicionOpcion;
      this.items = aux;
    },
    blurPanel(i) {
      let aux = JSON.parse(JSON.stringify(this.items));
      aux.forEach((element) => {
        delete element.editando;
      });
      aux[i].panel = this.fieldEdicionPanel;
      this.items = aux;
    },
    //COMPATIBILIDADES
    dibujarTablero(aux) {
      if (!this.keyManejando) return;
      let op_select = this.keyManejando;
      let i = op_select.i_panel;
      let i_a = op_select.i_opcion;
      let incomp = op_select.incomp;
      incomp = incomp ? incomp : [];
      aux.forEach((element, elem_i) => {
        let ops = element.opciones;
        ops.forEach((op) => {
          delete op.linkPre;
          delete op.linkPost;
          let found = false;
          if (op.id == op_select.id) {
            op.linkPre = false;
            op.linkPost = false;
          }
          if (element.tipo == "multi" && i == elem_i) {
            if (op.id != op_select.id) {
              found = incomp.find((e) => e == op.id);
              if (found) {
                op.linkPost = "red";
              } else {
                op.linkPost = "green";
              }
            }
          }
          if (i < elem_i) {
            found = incomp.find((e) => e == op.id);
            if (found) {
              op.linkPre = "red";
            } else {
              op.linkPre = "green";
            }
          }
          delete op.manejando;
        });
      });
      aux[i].opciones[i_a].manejando = true;
      this.items = aux;
    },
    compaMarcarOpcion(i, i_a, op_select) {
      let aux = JSON.parse(JSON.stringify(this.items));
      aux[i].opciones[i_a].manejando = true;
      op_select.i_panel = i;
      op_select.i_opcion = i_a;
      this.keyManejando = op_select;
      this.dibujarTablero(aux);
    },
    marcarComp(op) {
      let aux = JSON.parse(JSON.stringify(this.items));
      let op_select = this.keyManejando;
      if (op_select.incomp) {
        let found = op_select.incomp.find((e) => e == op.id);
        if (found) {
          this.removeA(op_select.incomp, op.id);
        } else {
          op_select.incomp.push(op.id);
        }
      } else {
        op_select.incomp = [op.id];
      }
      aux[op_select.i_panel].opciones[op_select.i_opcion] = op_select;
      this.keyManejando = op_select;
      this.dibujarTablero(aux);
    },
    claseOpcion(op) {
      return op.manejando ? "info" : "";
    },
    mostrarLinkPre(i, i_a) {
      if (i == 0) {
        return false;
      }
      return true;
    },
    limpiarOpcionCompatibilidades() {
      this.items.forEach((element, elem_i) => {
        let ops = element.opciones;
        ops.forEach((op) => {
          delete op.linkPre;
          delete op.linkPost;
          delete op.i_opcion;
          delete op.i_panel;
          delete op.manejando;
        });
      });
    },
    //MAPEO
    getColorMapeo(op) {
      return op.mapeoNeo ? "green" : "orange";
    },
    close() {
      this.dialogMapeo = false;
      let _vm = this;
      setTimeout(() => {
        _vm.reiniciarDatos();
      }, 300);
    },
    openDialogMapeando(item) {
      this.dialogMapeo = true;
      this.itemMapeando = item;
      var opcionesTabla = [];
      if (this.productoEditando.mapeoNeo) {
        //montamos la tabla de opciones de Neo
        let mapeoProducto = this.productoEditando.mapeoNeo;
        let foundOpciones = this.productosNeo.find(
          (e) => e.Codigo == mapeoProducto
        );
        if (
          foundOpciones &&
          foundOpciones.Elementos &&
          foundOpciones.Elementos.length > 0
        ) {
          let elementos = foundOpciones.Elementos;
          elementos.forEach((e) => {
            let codElemento = e.CodigoElemento;
            e.Opciones.forEach((op) => {
              opcionesTabla.push({
                Codigo: op.Componente,
                nombreNeo: op.NombreComponente,
                codElemento: codElemento,
              });
            });
          });
        }
        this.productosNeoOpciones = opcionesTabla;
        //marcamos en la tabla que corresponda el mapeo seleccionado
        let found2 = this.productosNeoOpciones.find(
          (e) => e.Codigo == item.mapeoNeo
        );
        if (found2) {
          this.selectedNeoOpcion.push(found2);
        } else {
          let found = this.productosNeo.find((e) => e.Codigo == item.mapeoNeo);
          if (found) this.selectedNeo.push(found);
        }
      }
    },
    reiniciarDatos() {
      this.itemMapeando = null;
      this.searchNeo = "";
      this.selectedNeo = [];
      this.selectedNeoOpcion = [];
    },
    getProductosNeo() {
      let _vm = this;
      this.loading = true;
      this.$store
        .dispatch("negocios/getProductosNeo")
        .then((res) => {})
        .catch((error) => {
          _vm.$store.commit("snackbar/setMensajeDanger", {
            msj: "Error al conectar con Neo: " + error,
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getProductosNeoOpciones() {
      if (!this.productoEditando.mapeoNeo) {
        alert("El producto general no está mapeado");
        return false;
      }
      console.log(this.productoEditando);
    },
    saveMapeo() {
      let m = this.selectedNeo[0];
      let selected =
        this.selectedNeo.length > 0
          ? this.selectedNeo[0]
          : this.selectedNeoOpcion[0];

      if (selected) {
        console.log(selected);
        if (selected.Codigo) {
          this.itemMapeando.mapeoNeo = selected.Codigo ? selected.Codigo : null;
          this.itemMapeando.mapeoNeoTipo = selected.Tipo ? selected.Tipo : null;
          delete this.itemMapeando.mapeoNeoPrecio;
        } else {
          delete this.itemMapeando.mapeoNeoTipo;
          this.itemMapeando.mapeoNeo = selected.codigo;
          this.itemMapeando.mapeoNeoPrecio = selected.precio;
        }
      } else {
        delete this.itemMapeando.mapeoNeoPrecio;
        delete this.itemMapeando.mapeoNeo;
        delete this.itemMapeando.mapeoNeoTipo;
      }
      this.close();
    },
  },
  mounted() {
    this.items = this.$store.state.productos.opcionesEditadas
      ? this.$store.state.productos.opcionesEditadas
      : [];

    //this.construirOpcionesPrueba();
  },
};
</script>

<style>
</style>